import BaseModel from "nexia_mobile/models/base_model";
import Url from "nexia_mobile/url";

export default class Mode extends BaseModel {
  onParse(rawAttrs) {
    let attrs = super.onParse(rawAttrs);

    if (attrs.hasOwnProperty("current_mode")) {
      attrs.enabled = attrs.current_mode;
      delete attrs.current_mode;
    }

    if (attrs.icon) {
      let filename = Url.getFilename(attrs.icon);
      attrs.icon = filename.substr(0, filename.lastIndexOf(".")) || filename;
    }

    return attrs;
  }
}



// WEBPACK FOOTER //
// ./src/models/mode.js